/**
 * Persistance locale des préférences.
 *
 * Le mode d'exécution, la paire, les paramètres de compte et les derniers prix
 * saisis survivent à un rechargement : sur mobile, l'app est régulièrement
 * suspendue puis relancée par iOS, et tout retaper à chaque fois serait
 * inutilisable.
 *
 * Chaque accès est protégé : en navigation privée iOS, `localStorage` peut
 * lever une exception à l'écriture. Une préférence perdue ne doit jamais
 * empêcher l'application de fonctionner.
 */

const PREFIX = 'reversetrader.'

export function loadStored<T>(key: string, fallback: T): T {
  try {
    const raw = window.localStorage.getItem(PREFIX + key)
    if (raw === null) return fallback
    return JSON.parse(raw) as T
  } catch {
    return fallback
  }
}

export function storeValue(key: string, value: unknown): void {
  try {
    window.localStorage.setItem(PREFIX + key, JSON.stringify(value))
  } catch {
    // Quota dépassé ou stockage refusé : on continue sans persistance.
  }
}
